<template>
      <div class="wrapper reveal-side-navigation">
    <main id="top" class="masthead header-bg" role="main">
        <div class="container">
								
            <div class="mainheader1">
                <h3 style="color:#73D2B6; margin-top:30px; font-size: 50px;">Ship My Excess Baggage – Door To Door</h3>
				<p style="font-size: 17px;">Ship Your Excess Baggage All Over The World With Our Door To Door Excess Baggage Delivery Service. Sending Baggage is easy with AiroLuggage.</p>
            </div>
			
				<div id="quick-quote-header" style="background-color:#73D2B6; width:60%; height:80px;border-radius:5px; margin: 0 auto;">
						<center>
							<h3 class="icon-aircraft-take-off color-airoluggage" style="margin-top:10px;color: white;"><label>
								<a href="https://airoluggage.com/"><h3><b>Quick Quote</b></h3></a>
						</label></h3>
						</center>
				</div>
			
			<h5 style="color: white; font-size: 20px; margin-top:20px;">Excess Baggage Delivery Door To Door</h5>
			<p>Best Price Guaranteed · 24hr Support · Instant Online Quote · Fast Delivery to Your Door.</p>
</div>
    </main>

    <div class="container" id="explore">
    
        <section class="supporing-content">
            <div class="row has-padding-top">
                <div class="col-md-7">
					<h1 style="margin-top:64px; font-size:2.476rem;">Send Excess Baggage around the world with AiroLuggage</h1>
					
					<h2>Why Ship Excess Baggage?</h2>
					
                    <p>Our Door To Door Excess Baggage Delivery Service offers complete convenience. Avoid check in queues, baggage carousels, and enjoy a stress-free journey by letting AiroLuggage transfer your Excess Baggage.</p> 
					<p>Dragging Excess Baggage through the airport will soon be a thing of the past. Who wants to carry Excess Baggage aswell as children through a busy airport or around busy pedestrianised areas?</p>
					
					<h4>Send Excess Baggage to Europe</h4>
					
					<p>Below are our most popular Excess Baggage Shipping Destinations</p>
					
						<ol>
							<li>Perth, Australia</li>
							<li>Los Angeles, USA</li>
							<li>Johannesburg, South Africa</li>
							<li>Madrid, Spain</li>
							<li>Lyon, France</li>
							<li>Manchester, UK</li>
							<li>Auckland, New Zealand</li>
							<li>Amsterdam, Netherlands</li>
							<li>Dublin, Ireland</li>
							<li>Rome, Italy</li>
						</ol>
											
					<br><br>
					
					<h4>How does Excess Baggage Shipping work?</h4>
					
					<p>It’s very simple, book you Excess Baggage online and make payment, then we will email you the shipping labels and post the labels holders. All you have to do is relax until your Excess Baggage is collected by one of our drivers. Once collected you can track your equipment on your mobile phone until delivery.</p>
					
					<p>Our service within the UK is next day delivery, within the EU it’s a 3-5 days and internationally 3- 5 days. We offer a USA next day delivery service (within 24 hours) depending where you are sending your equipment from in the UK or USA.</p>


					<h4>Is it cheaper to ship your Excess Baggage?</h4>

					<p>Not only is it cost effective to send your Excess Baggage ahead but also stress free. Imagine breezing through the airport hands free and straight through to security? Or Imagine the convenience of sending your bags back home without having to worry about lugging them to your next destination?</p>

					<h4>Send Oversized Excess Baggage to your destination and save time and money!</h4>

					<p>We also offer a generous allowance of up to 30kg per item. Avoid the stress of carting Excess Baggage around with you when you can send it ahead with our Excess Baggage Forwarding Service. </p>

					<h4>Countries where you can send your Excess Baggage to</h4>
						<ul>
							<li>Excess Baggage shipping Canada</li>
							<li>Excess Baggage courier Spain</li>
							<li>Excess Baggage Shipping USA</li>
							<li>Send Excess Baggage ahead France</li>
							<li>Shipping Excess Baggage to Scotland</li>
							<li>Excess Baggage Delivery England</li>

					<h4>Who can use our Excess Baggage delivery service?</h4>
							<li>Students</li>
							<li>Travellers</li>
							<li>Business travellers</li>
							<li>Expats</li>
							<li>NGOs</li>
							<li>Holidaymakers </li>
						</ul>

					<h4>Baggage Collection and Delivery</h4>

					<p>Using our Door To Door Excess Baggage delivery service means we collect your Excess Baggage from you home and deliver it straight to your destination. We will collect your bags and deliver them exactly to where they need to go. </p> 

					<h4>Shipping Excess Baggage from UK to USA</h4>

					<p>Being one of our most popular routes we offer a 24 hour next day delivery service from certain cities in the UK and USA. It really is the best service on the market. We can ship your Excess Baggage Monday to Friday on this route, and have one of the best delivery records on the market.</p>
					
                    <h4>Excess Baggage Process</h4>

                    <p>Excess baggage shipping is a service that allows you to send your luggage ahead of time so that you can travel lighter, while still having all of your belongings with you at your destination! This is a great option for students and travellers, and it's easy to use!</p>
                    <p>First step: Get a Quick Quote from AiroLuggage. If you're looking to send your luggage ahead, we recommend using our simple and convenient online form. Enter the country you'd like to collect your luggage from, where you'd prefer it delivered to, and a collection deadline. You'll receive a quote and estimated delivery date within seconds.</p>
                    <p>Our service is free for all customers. You won't pay anything extra for your shipment when you book through us. Our aim is to provide an easy, hassle-free experience for everyone. You'll also get a quote within seconds of booking and can then compare prices before booking if necessary. If you'd like to check out other courier companies, please visit our comparison page here.</p>
                    <p>If you are happy with the price we have quoted you then simply click the ‘Book Now’ button on our website. You will need to enter some information about yourself and your shipment details. Once you have done this, you will receive an automated response confirming that your request has been received. If you are satisfied with this price, you may proceed to complete your booking. Please note that we cannot guarantee delivery times before or after this time frame.</p>
                    <p>You can get your labels ahead of time. Once you've received the confirmation email, you can go to the website and click "Print Labels" under "My Bookings". The system will then generate a PDF file containing your labels. Print out those and attach them to your bags. Make sure to check that there aren't any mistakes! If you're printing a lot of labels, we recommend getting yourself a Label Holder - it's really easy to use and they come in different sizes.</p>
                    <p>You will receive an email containing instructions for completing the customs form. You must print and attach this form to your luggage before leaving the country. If you forget to do this, we will not be able to send your item(s) until after you arrive at your destination. We recommend printing the form on both sides of the paper. Make sure you fill out all fields completely and accurately. Please note that if you use a printer other than the one provided, you may have to adjust the settings for each page.</p>
                    <p>Our shipping company ensures that our punctuality standards remain high at all times. We understand that there can be delays during transit, especially when the shipment needs to be delivered to an address far away. For this reason, we offer 24/7 customer care assistance to keep track of your shipments and provide updates on the status of your goods. You can also check the progress of your shipment using our online tracking system.</p>
                    <p>We try our best to meet delivery times, but there may be delays due to weather conditions, traffic congestion, roadworks, strikes or other circumstances beyond our control. We also cannot guarantee that the driver will arrive at the specified time. If you are unable to collect your item(s) within the specified time frame, please contact us via phone or email to arrange an alternative date and time.</p>
                    <p>Sign in to your account and click “Track Your Package” to see where your package is at any given time. You can also choose to track your package internationally if you wish.</p>
                    <p>We have an excellent track record of getting parcels delivered on time. But because there are many factors that could cause delays, we recommend giving yourself a few extra minutes before leaving for pick up. Your items will still be waiting for you when you return, even if you miss the estimated arrival time. And if you've got questions about your shipment, just contact us directly!</p>
                    <p>Send luggage overseas using our Excess Baggage Company's baggage shipping services. Use our courier and freight delivery services to send your overweight baggage anywhere worldwide cost-effectively. Get your free online quote today.</p>
                    <p>AiroLuggage provides safe and secure shipment of your belongings worldwide. Our team consists of highly trained professionals who ensure that your valuables arrive safely at their destination. We follow the highest standards of safety and security throughout all stages of transport. Therefore, you can rest assured that we will provide you with excellent service while transporting your goods.</p>
                    <p>Our customer service representatives are available 24/7 to assist you with any issue related to your baggage. You can contact us above. If you need assistance while travelling, you can also check our website for updates on flight delays, cancellations and other information.</p>


 



					

                </div>
                <div class="col-md-5"> 
					<div>
						<h3 style="margin-top:64px;">Door To Door Excess Baggage delivery service</h3>
						<p>You can send Baggage, boxes, golf bags, bikes and skis/snowboards or send a parcel.</p>
							<div style="margin-left:0px;">	
								<h4>Benefits of our services</h4>
									<ul>
										<li>Collection time between 12pm-4.30pm</li>
										<li>Free luggage protection of £100</li>
										<li>Live tracking</li>
										<li>Door-2-Door delivery service</li>
										<li>United Kingdom</li>
									</ul>
							</div>
					</div>
					
									<div id="quick-quote-header" style="background-color:#73D2B6; width:70%; height:80px;border-radius:5px;">
						<center>
							<h3 class="icon-aircraft-take-off color-airoluggage" style="margin-top:10px;color: white;"><label>
								<a href="https://airoluggage.com"><h3><b>Quick Quote</b></h3></a>
						</label></h3>
						</center>
        </div>
<img class='map-img' src=''>
            </div>
            </div>
        </section>
			<br><br>

        <div class="section-title">
            <h2>We pride ourselves on outstanding delivery</h2>
            <h4>We have independent reviews on Trustpilot, try our services and leave a review today.</h4>
        </div>
  
    </div>

    <section class="highlight">
        <div class="container">

            <div class="section-title">
                <h2>Your Luggage Delivered Door-2-Door</h2>
                <h4>Whether you’re moving abroad, sending luggage to a friend or going on holiday we collect your baggage from <br>your home and deliver it straight to your destination.</h4>
            </div>

            <div class="row has-margin-bottom">
                <div class="col-md-12 text-center"> <a href="#top" class="btn btn-primary btn-lg">Call us on 0333 344 6692</a> </div>
				<br><br>&nbsp;
            </div>
        </div>
    </section>

     <div class="container">
        <section class="row breath">
            <div class="col-md-12 footerlinks">
                <p></p>
            </div>
        </section>

    </div>
</div>
</template>

    <script>
export default {
  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://airoluggage.com/lpshipping/excess-baggage'}
    ],
    script: [{
      type: 'application/ld+json',
      json: [
        {
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "Ship My Excess Baggage – Door To Door",
          "author": [{
            "@type": "Organization",
            "name": "AiroLuggage",
            "url": "https://airoluggage.com"
          }]
        }, {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Ship My Excess Baggage – Door To Door",
          }]
        },
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "Why Ship Excess Baggage?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our Door To Door Excess Baggage Delivery Service offers complete convenience. Avoid check in queues, baggage carousels, and enjoy a stress-free journey by letting AiroLuggage transfer your Excess Baggage.\n" +
                  "\n" +
                  "Dragging Excess Baggage through the airport will soon be a thing of the past. Who wants to carry Excess Baggage aswell as children through a busy airport or around busy pedestrianised areas?"
            }
          }, {
            "@type": "Question",
            "name": "Send Excess Baggage to Europe",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "<p>Below are our most popular Excess Baggage Shipping Destinations</p><ol><li>Perth, Australia</li><li>Los Angeles, USA</li><li>Johannesburg, South Africa</li><li>Madrid, Spain</li><li>Lyon, France</li><li>Manchester, UK</li><li>Auckland, New Zealand</li><li>Amsterdam, Netherlands</li><li>Dublin, Ireland</li><li>Rome, Italy</li></ol>"
            }
          }, {
            "@type": "Question",
            "name": "How does Excess Baggage Shipping work?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "It’s very simple, book you Excess Baggage online and make payment, then we will email you the shipping labels and post the labels holders. All you have to do is relax until your Excess Baggage is collected by one of our drivers. Once collected you can track your equipment on your mobile phone until delivery.\n" +
                  "\n" +
                  "Our service within the UK is next day delivery, within the EU it’s a 3-5 days and internationally 3- 5 days. We offer a USA next day delivery service (within 24 hours) depending where you are sending your equipment from in the UK or USA."
            }
          }, {
            "@type": "Question",
            "name": "Is it cheaper to ship your Excess Baggage?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Not only is it cost effective to send your Excess Baggage ahead but also stress free. Imagine breezing through the airport hands free and straight through to security? Or Imagine the convenience of sending your bags back home without having to worry about lugging them to your next destination?"
            }
          }, {
            "@type": "Question",
            "name": "Send Oversized Excess Baggage to your destination and save time and money!",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"We also offer a generous allowance of up to 30kg per item. Avoid the stress of carting Excess Baggage around with you when you can send it ahead with our Excess Baggage Forwarding Service."}
          }, {
            "@type": "Question",
            "name": "Countries where you can send your Excess Baggage to",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<ul><li>Excess Baggage shipping Canada</li><li>Excess Baggage courier Spain</li><li>Excess Baggage Shipping USA</li><li>Send Excess Baggage ahead France</li><li>Shipping Excess Baggage to Scotland</li><li>Excess Baggage Delivery England</li></ul>"}
          }, {
            "@type": "Question",
            "name": "Who can use our Excess Baggage delivery service?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<ul><li>Students</li><li>Travellers</li><li>Business travellers</li><li>Expats</li><li>NGOs</li><li>Holidaymakers </li></ul>"}
          }, {
            "@type": "Question",
            "name": "Baggage Collection and Delivery",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"Using our Door To Door Excess Baggage delivery service means we collect your Excess Baggage from you home and deliver it straight to your destination. We will collect your bags and deliver them exactly to where they need to go."}
          }, {
            "@type": "Question",
            "name": "Shipping Excess Baggage from UK to USA",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"Being one of our most popular routes we offer a 24 hour next day delivery service from certain cities in the UK and USA. It really is the best service on the market. We can ship your Excess Baggage Monday to Friday on this route, and have one of the best delivery records on the market."}
          }, {
            "@type": "Question",
            "name": "What is the cheapest way to ship a suitcase?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"Excess baggage shipping is a service that allows you to send your luggage ahead of time so that you can travel lighter, while still having all of your belongings with you at your destination! This is a great option for students and travellers, and it's easy to use!\n" +
                  "\n" +
                  "First step: Get a Quick Quote from AiroLuggage. If you're looking to send your luggage ahead, we recommend using our simple and convenient online form. Enter the country you'd like to collect your luggage from, where you'd prefer it delivered to, and a collection deadline. You'll receive a quote and estimated delivery date within seconds.\n" +
                  "\n" +
                  "Our service is free for all customers. You won't pay anything extra for your shipment when you book through us. Our aim is to provide an easy, hassle-free experience for everyone. You'll also get a quote within seconds of booking and can then compare prices before booking if necessary. If you'd like to check out other courier companies, please visit our comparison page here.\n" +
                  "\n" +
                  "If you are happy with the price we have quoted you then simply click the ‘Book Now’ button on our website. You will need to enter some information about yourself and your shipment details. Once you have done this, you will receive an automated response confirming that your request has been received. If you are satisfied with this price, you may proceed to complete your booking. Please note that we cannot guarantee delivery times before or after this time frame.\n" +
                  "\n" +
                  "You can get your labels ahead of time. Once you've received the confirmation email, you can go to the website and click \"Print Labels\" under \"My Bookings\". The system will then generate a PDF file containing your labels. Print out those and attach them to your bags. Make sure to check that there aren't any mistakes! If you're printing a lot of labels, we recommend getting yourself a Label Holder - it's really easy to use and they come in different sizes.\n" +
                  "\n" +
                  "You will receive an email containing instructions for completing the customs form. You must print and attach this form to your luggage before leaving the country. If you forget to do this, we will not be able to send your item(s) until after you arrive at your destination. We recommend printing the form on both sides of the paper. Make sure you fill out all fields completely and accurately. Please note that if you use a printer other than the one provided, you may have to adjust the settings for each page."}
          }]
        }
      ]
    }],
  },
};
</script>

<style lang="css" scoped>
@charset "utf-8";

/*========== 1. GLOBAL STYLES ==============*/

body {
    font-family: "Montserrat", Arial, sans-serif;
    background: #fff;
    font-weight: 400;
    height: 100%;
    margin: 0;
    padding: 0;
    color: #94a3a8;
    line-height: 1.5;
}

strong,
b {
    font-weight: 600;
}

h1 h2,
h3,
h4,
h5,
h6 {
    color: #323e4f;
}

h1 {
    font-size: 50px;
    line-height: 1.5;
    margin: 25px 0;
}

h2 {
    font-size: 28px;
    font-weight: 700;
    margin: 15px 0;
}

h3 {
    font-size: 18px;
    margin: 10px 0;
    font-weight: 700;
}

h4 {
    font-size: 22px;
    margin: 10px 0;
    font-weight: 700;
    line-height: 1.5;
}

h5 {
    font-size: 18px;
    margin: 15px 0;
}

h6 {
    font-size: 16px;
    margin: 10px 0;
}

a {
    color: #5173bd;
}

a:hover,
a:focus {
    color: #5173bd;
    text-decoration: none;
}

.btn,
.btn-lg,
.input-lg {
    border-radius: 3px;
}

.form-control {
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.input-lg {
    height: 55px;
}

.btn-lg,
.btn-group-lg > .btn {
    padding: 13px 28px;
}

.form-control:focus {
    border-color: #afbdc8;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.breath {
    margin: 35px auto;
}

.highlight {
    background: #f4f4f4;
    margin-top: 40px;
}

.has-no-margin {
    margin: 0;
}

.has-no-padding {
    padding: 0;
}

.has-no-padding-horizontal {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.has-margin-vertical {
    margin: 20px 0 30px;
}

.has-margin-top {
    margin-top: 40px;
}

.has-margin-bottom {
    margin-bottom: 40px;
}

.has-padding-top {
    padding-top: 40px;
}

.has-padding-bottom {
    padding-top: 40px;
}

/*========== 1 a. SUB PAGES ==============*/

.subpage-head {
    background-color: #f4f4f4;
    padding-top: 20px;
    padding-bottom: 15px;
    margin-bottom: 40px;
}

/*========== 2. HEADER ==============*/

.masthead {
    position: relative;
    padding: 20px 15px;
    color: #fff;
    text-align: center;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    background-color: #323e4f;
}

.masthead .main-title {
    margin-bottom: 0;
}

.masthead .sub-title {
    color: #adb8c7;
    margin-top: 0;
}

.bg-family {
    background-color: #323e4f;
    /*background-image: url(../../../public/images/header_bg_gradient.jpg);*/
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

/*animation ends*/
.btn-large {
    font-size: 18px;
    padding: 20px 50px;
    margin: 5px 10px;
}

.btn-success {
    background-color: #2ecc71;
    background-image: none;
    border: 0;
    -webkit-box-shadow: 0 3px 0 rgba(2, 154, 67, 1);
    box-shadow: 0 3px 0 rgba(2, 154, 67, 1);
    line-height: 1.8;
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active {
    background-color: #29c36a;
    color: #fff;
    border: 0;
    -webkit-box-shadow: 0 3px 0 rgba(2, 139, 61, 1);
    box-shadow: 0 3px 0 rgba(2, 139, 61, 1);
}

.btn-primary {
    background-color: #2db6d8;
    background-image: none;
    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
    background-color: #209ab8 !important;
    color: #fff !important;
}

.btn-warning {
    line-height: 1.8;
    -webkit-box-shadow: 0 3px 0 rgb(177, 116, 29);
    box-shadow: 0 3px 0 rgb(177, 116, 29);
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active {
    -webkit-box-shadow: 0 3px 0 rgb(177, 116, 29);
    box-shadow: 0 3px 0 rgb(177, 116, 29);
}

.subscribe {
    padding: 45px 0;
}

.alertMsg {
    font-size: 14px;
    display: block;
    padding: 5px 17px;
    text-align: center;
}

.masthead .form-control {
    border: 0;
}

.form-control::-moz-placeholder {
    color: #848e93;
}

.form-control:-ms-input-placeholder {
    color: #848e93;
}

.form-control::-webkit-input-placeholder {
    color: #848e93;
}

/* Boucing Arrow Animation */

@keyframes arrowbounce {
    from {
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        transform: translateY(0);
    }
    to {
        -webkit-transform: translateY(-20px);
        -moz-transform: translateY(-20px);
        transform: translateY(-20px);
    }
}

@-moz-keyframes arrowbounce {
    /* Firefox */
    from {
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        transform: translateY(0);
    }
    to {
        -webkit-transform: translateY(-20px);
        -moz-transform: translateY(-20px);
        transform: translateY(-20px);
    }
}

@-webkit-keyframes arrowbounce {
    /* Safari and Chrome */
    from {
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        transform: translateY(0);
    }
    to {
        -webkit-transform: translateY(-20px);
        -moz-transform: translateY(-20px);
        transform: translateY(-20px);
    }
}

@-o-keyframes arrowbounce {
    /* Opera */
    from {
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        transform: translateY(0);
    }
    to {
        -webkit-transform: translateY(-20px);
        -moz-transform: translateY(-20px);
        transform: translateY(-20px);
    }
}

.scrollto,
.scrollto:hover {
    margin: 30px;
    display: block;
    color: #fff;
    text-decoration: none;
    width: 200px;
    margin: 0 auto;
}

.scrollto small {
    color: #adb8c7;
}

.scrollto--arrow {
    padding: 20px;
    padding-bottom: 0;
}

.scrollto--arrow img {
    animation: arrowbounce 1s alternate infinite;
    -moz-animation: arrowbounce 1s alternate infinite;
    /* Firefox */
    -webkit-animation: arrowbounce 1s alternate infinite;
    /* Safari and Chrome */
    -o-animation: arrowbounce 1s alternate infinite;
    /* Opera */
}

/*Header Contact Form*/

.contact-form {
    background: #4a5565;
    border-radius: 3px;
    padding: 15px;
    text-align: left;
    position: relative;
}

.contact-form .mini-title {
    margin-bottom: 20px;
    line-height: 1.5;
    color: #fff;
}

.dark-input {
    background: #353f4d;
    color: #fff;
}

.loading p {
    margin: 10px 0 0 0;
    text-align: center;
}

.point-arrow {
    position: absolute;
    left: -65px;
    top: -30px;
}

/*Quick Features*/

.quick-features {
    text-align: left;
}

.features-lead {
    margin-bottom: 30px;
    color: #323e4f;
}

.featues-single {
    margin-bottom: 30px;
}

.featues-single img {
    margin-right: 25px;
}

.featues-single h5 {
    margin-bottom: 10px;
    margin-left: 85px;
    color: #323e4f;
}

.featues-single p {
    color: #adb8c7;
    margin-left: 85px;
    margin-bottom: 0;
}

.masthead .featues-single h5,
.masthead .features-lead {
    color: #fff;
}

/*========== 3. HERO IMAGE ==============*/

.section-title {
    margin-top: 60px;
    margin-bottom: 30px;
    font-weight: 700;
    text-align: center;
}

.section-title h2 {
    color: #384047;
    margin-bottom: 10px;
}

.section-title h4 {
    color: #94a3a8;
    font-weight: normal;
    font-size: 18px;
    margin-top: 0;
}

.heroimg img,
.clientlogo img {
    max-width: 100%;
}

/*========== 4. FEATURES ==============*/

.features {
    margin: 25px 0;
}

.thumbnail {
    border: 0;
    text-align: center;
}

.thumbnail .caption p {
    color: #94a3a8;
}

/*Hover Animation*/

.thumbnail img {
    -moz-transition: all 0.6s ease;
    -webkit-transition: all 0.6s ease;
    -ms-transition: all 0.6s ease;
    -o-transition: all 0.6s ease;
    transition: all 0.6s ease;
}

.thumbnail:hover img {
    -moz-transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -o-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
    z-index: 2;
}

/*Video Block*/

.video-block {
    max-width: 620px;
    margin: 0 auto;
}

.videoWrapper {
    position: relative;
    padding-bottom: 43.65%;
    /* 56.25%;  16:9 */
    padding-top: 25px;
    height: 0;
}

.videoWrapper > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.videoWrapper > .frameCover {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: none;
}

/*========== 5. TESTIMONIALS ==============*/

.testblock {
    width: 100%;
    height: auto;
    padding: 20px;
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-family: Georgia, "Times New Roman", Times, serif;
    font-style: italic;
    position: relative;
    line-height: 28px;
    font-size: 16px;
}

.testblock:after {
    top: 100%;
    left: 20%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #ffffff;
    border-width: 15px;
    margin-left: -15px;
}

.clientblock {
    margin-top: 40px;
    margin-left: 10px;
    text-align: center;
}

blockquote {
    margin: 0 0 10px;
    font-size: 20px;
    border-left: none;
    text-align: center;
    font-family: Georgia, serif;
    font-style: italic;
}

.clientblock img {
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
}

.clientblock p {
    padding-top: 13px;
}

.clientblock p strong {
    color: #384047;
    font-size: 16px;
}

/* Animation */

.testblock {
    -moz-transition: all 0.6s ease;
    -webkit-transition: all 0.6s ease;
    -ms-transition: all 0.6s ease;
    -o-transition: all 0.6s ease;
    transition: all 0.6s ease;
}

.testblock:hover {
    -moz-transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -o-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
    z-index: 2;
}

/*========== 6. PLANS AND PRICING ==============*/

.pricing {
    padding: 25px;
    color: #fff;
    text-align: center;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
}

.pricing .planname {
    text-transform: uppercase;
    font-weight: 600;
}

.pricing .price {
    font-size: 52px;
    font-weight: 300;
    margin: 10px 0;
}

.pricing .billing {
    text-transform: uppercase;
    color: #fff;
    opacity: 0.7;
}

.pricing .price .curr {
    display: inline-block;
    font-size: 20px;
    vertical-align: super;
}

.pricing .price .per {
    display: inline-block;
    font-size: 20px;
    vertical-align: baseline;
}

.color1 {
    background-color: #5ca2e0;
}

.color2 {
    background-color: #7676c6;
}

.color3 {
    background-color: #885fc1;
}

/* Animation */

.pricing {
    -moz-transition: all 0.6s ease;
    -webkit-transition: all 0.6s ease;
    -ms-transition: all 0.6s ease;
    -o-transition: all 0.6s ease;
    transition: all 0.6s ease;
}

.pricing:hover {
    -moz-transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -o-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
    z-index: 2;
}

/*========== 7. FAQ ==============*/

.faq p {
    margin-bottom: 25px;
}

/*==========8. FOOTER ==============*/

.footercta {
    padding: 60px 15px;
    color: #fff;
    text-align: center;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    background-color: #323e4f;
}

.footercta .section-title {
    margin-top: 0;
}

.footercta .section-title h2 {
    color: #fff;
}

.footerlinks {
    text-align: center;
}

.footerlinks a {
    text-align: center;
    padding: 0 13px;
    display: inline-block;
    padding-bottom: 15px;
}

/*==========9. CUSTOM MEDIA QUERIES==============*/

/*MEDIA QUERIES*/

@media (max-width: 991px) {
    h1 {
        font-size: 35px;
        line-height: 50px;
        margin: 15px 0;
    }
    h2 {
        font-size: 35px;
    }
    .testimonials [class*="col-"]:not(:first-child) {
        margin-top: 40px;
    }
    .planpricing [class*="col-"]:not(:first-child) {
        margin-top: 30px;
    }
    .breath {
        margin: 30px auto;
    }
}

@media (max-width: 767px) {
    h1 {
        font-size: 30px;
        line-height: 40px;
    }
    h2 {
        font-size: 30px;
        line-height: 40px;
    }
    .subscribe [class*="col-"]:not(:first-child) {
        margin-top: 30px;
    }
    .masthead {
        padding: 40px 15px;
    }
}

@media (max-device-width: 992px) {
    .masthead {
        background-size: cover;
        background-attachment: scroll;
    }
}

.signup-block {
    padding: 20px;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 7px;
    margin-bottom: 25px;
}

.form-group.last {
    margin-bottom: 0;
}

.multiple-btns .btn + .btn {
    margin: 10px;
}

/*=== Navigation ===*/

.navbar-default {
    background-color: #fff;
    border-color: #e0e0e0;
}

.navbar-default .navbar-brand,
.navbar-default .navbar-brand:hover {
    color: #fff;
    font-weight: bold;
}

.navbar-default .navbar-nav > li > a {
    color: #333;
    text-transform: uppercase;
    font-weight: bold;
}

.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
    color: #333;
    background-color: rgba(255, 255, 255, 0.22);
}

.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
    color: rgba(0, 0, 0, 0.5);
    background-color: transparent;
}

.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
    color: #333;
    background-color: rgba(255, 255, 255, 0.21);
}

.navbar-brand {
    padding: 8px 15px;
}

/*
 ------ LIGHT LAYOUT -------
 */

.light .masthead {
    background: #fcf9f5;
    /* Old browsers */
    background: -moz-linear-gradient(top, #ffffff 50%, #fdf8f2 100%);
    /* FF3.6+ */
    background: -webkit-gradient(
        linear,
        left top,
        left bottom,
        color-stop(50%, #ffffff),
        color-stop(100%, #fdf8f2)
    );
    /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(top, #ffffff 50%, #fdf8f2 100%);
    /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(top, #ffffff 50%, #fdf8f2 100%);
    /* Opera 11.10+ */
    background: -ms-linear-gradient(top, #ffffff 50%, #fdf8f2 100%);
    /* IE10+ */
    background: linear-gradient(to bottom, #ffffff 50%, #fdf8f2 100%);
    /* W3C */
    filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fdf8f2', GradientType=0);
    /* IE6-9 */
    color: #293342;
    padding-bottom: 0;
}

.light .masthead .sub-title {
    color: #909090;
    font-weight: normal;
}

.light .featues-single p {
    color: #b7babd;
}

.light .contact-form {
    background: #ffffff;
    border: 1px solid #ededed;
}

.light .form-control {
    border: 1px solid #ccc;
}

.light .contact-form .mini-title {
    color: #2db6d8;
    font-weight: bold;
}

.light .masthead .featues-single h5,
.light .masthead .features-lead {
    color: #6c6c6c;
}

/*Layout 3 Title and Image Separated*/

.masthead .bg-image {
    background: url(../../../public/images/edu-bg.jpg) center center no-repeat;
    background-size: cover;
}

.highlight .section-title {
    margin-top: 45px;
}

/*Layout 4 Full Header BG*/

.masthead.header-bg {
    background: url(../../../public/images/bg_bright1.png) top center no-repeat;
    background-size: cover;
}

.color-white {
    color: #fff !important;
}

/*Layout 5 Event */

.masthead.event {
    background: url(../../../public/images/event_bg.jpg) bottom no-repeat;
    background-size: cover;
}

@media (min-width: 767px) {
    .masthead.event {
        padding: 120px 15px;
    }
}

/*==========  BLOG ==============*/

.pagination > li > a,
.pagination > li > span {
    color: #483f34;
}

.pagination > li > a:hover,
.pagination > li > span:hover,
.pagination > li > a:focus,
.pagination > li > span:focus {
    color: #917e68;
}

.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
    background-color: #3289d6;
    border-color: #3172ac;
    color: #ffffff;
}

.vertical-links li {
    border-bottom: 1px solid #e6ddd4;
    padding: 8px 0;
}

.tag-cloud a {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 10px;
    padding: 2px 8px;
    border: 1px solid #eceae4;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    background: #f8f7f3;
    font-size: 12px;
}

.tag-cloud a:hover {
    text-decoration: none;
}

.comments-head {
    font-size: 35px;
    color: #53504c;
    border-bottom: 1px solid #f5f5f5;
    margin: 40px 0 20px;
    padding-bottom: 10px;
}

.comments-block > .media {
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 20px;
    margin-bottom: 20px;
}

.comments-block > .media .media {
    border-top: 1px solid #f5f5f5;
    padding-top: 20px;
}

.media-object {
    width: 40px;
}

/*========== SUB PAGES ==============*/

.subpage-head {
    background-color: #323e4f;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 40px;
    /*background-image: url(../../../public/images/header_bg.jpg);*/
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

.subpage-head .section-title h2 {
    color: #fff;
}

.subpage-head .section-title h4 {
    color: #adb8c7;
}

.subpage-head a {
    color: #fff;
    border-bottom: solid 1px #fff;
    text-decoration: none;
    padding-bottom: 5px;
}

.subpage-head a:hover,
.subpage-head a:focus,
.subpage-head a:active {
    color: rgba(255, 255, 255, 0.7);
    border-bottom: solid 1px rgba(255, 255, 255, 0.7);
    text-decoration: none;
}

/*version 2*/

/*Exit Intent Modal*/

#exit-modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

#exit-modal .underlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    -webkit-animation: fadein 0.5s;
    animation: fadein 0.5s;
}

#exit-modal .exit-modal {
    width: 600px;
    height: 400px;
    background-color: #f0f1f2;
    z-index: 1;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 4px;
    -webkit-animation: popin 0.3s;
    animation: popin 0.3s;
}

#exit-modal .modal-title {
    font-size: 18px;
    background-color: #fff;
    padding: 10px;
    margin: 0;
    border-radius: 4px 4px 0 0;
    text-align: center;
}

#exit-modal h3 {
    color: #2b9dd8;
    font-size: 1.4em;
    margin: 0.6em;
    text-transform: uppercase;
    font-weight: bold;
}

#exit-modal .modal-body {
    padding: 30px 40px;
}

#exit-modal p {
    color: #344a5f;
    line-height: 1.7em;
    font-size: 16px;
}

#exit-modal p strong {
    color: #ff8800;
}

#exit-modal .popup-cta {
    margin-top: 20px;
    margin-bottom: 20px;
}

#exit-modal form {
    text-align: center;
    margin-top: 35px;
}

#exit-modal form input[type="text"] {
    padding: 12px;
    font-size: 1.2em;
    width: 300px;
    border-radius: 4px;
    border: 1px solid #ccc;
    -webkit-font-smoothing: antialiased;
}

#exit-modal form input[type="submit"] {
    text-transform: uppercase;
    font-weight: bold;
    padding: 12px;
    font-size: 1.1em;
    border-radius: 4px;
    color: #fff;
    background-color: #4ab471;
    border: none;
    cursor: pointer;
    -webkit-font-smoothing: antialiased;
}

#exit-modal form p {
    text-align: left;
    margin-left: 35px;
    opacity: 0.8;
    margin-top: 1px;
    padding-top: 1px;
    font-size: 0.9em;
}

#exit-modal .modal-footer {
    position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
}

#exit-modal .modal-footer p {
    text-transform: capitalize;
    cursor: pointer;
    display: inline;
    border-bottom: 1px solid #344a5f;
}

@-webkit-keyframes fadein {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-ms-keyframes fadein {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes fadein {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-webkit-keyframes popin {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }
    85% {
        -webkit-transform: scale(1.05);
        transform: scale(1.05);
        opacity: 1;
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
}

@-ms-keyframes popin {
    0% {
        -ms-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }
    85% {
        -ms-transform: scale(1.05);
        transform: scale(1.05);
        opacity: 1;
    }
    100% {
        -ms-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes popin {
    0% {
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }
    85% {
        -webkit-transform: scale(1.05);
        -ms-transform: scale(1.05);
        transform: scale(1.05);
        opacity: 1;
    }
    100% {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
}

@media (max-width: 767px) {
    #exit-modal .exit-modal {
        width: 100%;
        height: 100%;
    }
}

.white {
    background-color: white;
}

.map-img {
    margin-top: 1.5em;
    max-width: 70%;
    max-height: 400px;
    width: auto;
    height: auto;
}
</style>